import bootstrap, { Carousel } from 'bootstrap';
import runRoi from './roi-implemented';

import './liveperson-scripts';

import './src/resources/scss/index.scss';
import { CONSENT_GROUPS, hasConsent } from './src/utils/consent';

export const onRouteUpdate = () => {
    window.dataLayer = window.dataLayer || [];
    window.runRoi = runRoi;

    const pagePath = location ? location.pathname + location.search + location.hash : undefined;

    if (location && window.Munchkin && hasConsent(CONSENT_GROUPS.performance)) {
        window.Munchkin.munchkinFunction('visitWebPage', {
            url: location.pathname,
            params: location.search,
        });
    }

    setTimeout(function () {
        const myCarouselElements = document.querySelectorAll('.carousel:not(#carouselExampleFlywheel)');
        myCarouselElements.forEach(function (myCarouselElement) {
            myCarouselElement.classList.add('testing-here4');
            new Carousel(myCarouselElement, {
                ride: 'carousel',
            });
        });
    }, 1000);
    window.locations = window.locations || [document.referrer];
    locations.push(window.location.href);
    window.previousPath = locations[locations.length - 2];

    if (location && window.OneTrust) {
        OneTrust.initializeCookiePolicyHtml();
    }

    console.log('onRouteUpdate', pagePath);
};
